module.exports = __webpack_public_path__ + "img/36599-096.25c277c2.jpg";